<template>
  <div
    ref="filter-item"
    class="filter"
  >
    <DpplAccordionPanels
      v-model="selectedPanelId"
      :items="filters"
    >
      <template #header="{ item }">
        <div class="panel-title-left">
          <p
            class="panel-title"
            :title="item.label"
          >
            {{ item.label }}
          </p>
          <AppliedFiltersDot
            v-if="originalFilters[item.originalIndex].value.length"
            class="ml-2"
          />
        </div>
        <button
          v-if="originalFilters[item.originalIndex].value.length"
          type="button"
          class="clear-current-filter"
          @click.stop="emit(
            'clearFilters',
            ({ index: item.originalIndex, router: $router }),
          )"
        >
          Clear
        </button>
      </template>
      <template #content="{ item }">
        <FilterExpandedCard
          :field="item"
          :inline-apply="false"
          @set-to-applied-filters="emit('resetValues', {
            fieldIndex: item.originalIndex,
            setToAppliedFilters: true,
          })"
          @set-temp-filters="emit('setTempFilters', {
            value: $event,
            index: item.originalIndex,
          })"
          @apply-filters="emit('applyFilters')"
          @add-snackbar="emit('addSnackbar')"
        />
      </template>
    </DpplAccordionPanels>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FilterExpandedCard from '@/components/filter/FilterExpandedCard.vue';
import DpplAccordionPanels from '@/components/datapeople/DpplAccordionPanels/DpplAccordionPanels.vue';
import AppliedFiltersDot from '@/components/filter/AppliedFiltersDot.vue';

defineProps({
  filters: {
    type: Object,
    default: () => {},
  },
  originalFilters: {
    type: Array,
    default: () => [],
  },
  hasAppliedFilters: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'resetValues', 'setTempFilters', 'applyFilters', 'addSnackbar', 'clearFilters',
]);

const selectedPanelId = ref(null);
</script>

<style lang="less" scoped>
.filter {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
}

.panel-title-left {
  overflow-x: hidden;
  display: flex;
  align-items: center;
}

.panel-title {
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
  line-height: 150%;
  margin-right: 4px;
  line-height: 150%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.clear-current-filter {
  font-size: 12px;
  font-weight: 500;
  color: @text-brand;
  padding: 0 10px;
  margin-left: auto;
}

.header-title {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
}

:deep(.tree-view-dropdown) {
  padding: 8px;
}
</style>
